var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit, ElementRef, } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { tap, map, distinctUntilChanged, filter, mergeMap, } from 'rxjs/operators';
// services
import { EventsService } from '../../core/services/events-service/events.service';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';
import { ProfileService } from '../../core/services/profile-service/profile.service';
import { 
// components
AlertComponent, 
// constants
getPhoneMask, tshirtSizes, scrollItType, stateList, includes, } from '../../shared';
import { isPaypalDefined } from '../../shared/utils/check-for-paypal';
import { nocList } from '../noc-list';
// tslint:disable-next-line:max-line-length
var mockData = JSON.parse(
// tslint:disable-next-line:max-line-length
'{"name_first":"AJ","name_middle":"","name_last":"Almaguer","birth_date":"2010-02-03","birth_date_helpers":{"birth_month":"02","birth_day":"03","birth_year":"2010"},"gender":"Female","rank":"2","height_ft":"4","height_in":"2","weight":"132","email":"aj@gmail.com","phone":"(123) 123-1231","address":"123 Fake st","address_2":"","city":"LA","state":"CA","zip":"12345","shirt_size":"Adult M","school":{"id":"100073"},"parent_name_first":"AJ","parent_name_middle":"","parent_name_last":"A","parent_email":"aj@gmail.com","parent_phone":"(123) 123-1231","subscription":false,"legal_age":true,"no_crime":true,"waiver":true,"terms_and_conditions":true,"catchall":true,"divisions":[950,973]}');
var CompetitorRegistrationComponent = /** @class */ (function () {
    function CompetitorRegistrationComponent(fb, calculateAge, scrollIt, eventService, route, profileService) {
        this.fb = fb;
        this.calculateAge = calculateAge;
        this.scrollIt = scrollIt;
        this.eventService = eventService;
        this.route = route;
        this.profileService = profileService;
        this.showValidation = false;
        this.eventId = '';
        this.divisions = [];
        this.price = '';
        this.successHtml = '';
        this.payload = null;
        this.hasSelectedPrefill = false;
        this.paymentCode = '';
        this.paypalDefined = false;
        this.weightMask = createNumberMask({
            prefix: '',
            includeThousandsSeparator: false,
            allowDecimal: true,
            decimalLimit: 1,
        });
        this.heightMask = createNumberMask({
            prefix: '',
            includeThousandsSeparator: false,
            allowDecimal: false,
        });
    }
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "shirtSizes", {
        // GETTERS
        get: function () {
            return tshirtSizes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "ranks", {
        get: function () {
            return this.eventService.ranks;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "waiver_description", {
        get: function () {
            return this.eventService.eventData.waiver_description;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "countryCodes", {
        get: function () {
            return nocList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "schools", {
        get: function () {
            return this.eventService.schools;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "stateList", {
        get: function () {
            return stateList;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "waiverText", {
        get: function () {
            return this.eventService.waiver.text;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "waiverHeader", {
        get: function () {
            return this.eventService.waiver.header;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "isClosed", {
        get: function () {
            return this.eventService.isRegistrationClosed('competitor');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "eventUrl", {
        get: function () {
            return this.eventService.eventData.url;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "profile", {
        get: function () {
            return this.profileService.profile;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "isGuest", {
        get: function () {
            return this.profileService.isGuest;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "isProcessorPaymentCode", {
        get: function () {
            return this.eventService.eventData.processors.payment_codes;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "isProcessorPayPal", {
        get: function () {
            return !!this.eventService.eventData.processors.paypal;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "isProcessorAuthNet", {
        get: function () {
            return !!this.eventService.eventData.processors.authorize_net;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "canPayByUpload", {
        get: function () {
            return includes(Object.keys(this.eventService.eventData.processors), 'pay_by_upload');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "payByUploadData", {
        get: function () {
            if (this.canPayByUpload) {
                return this.eventService.eventData.processors.pay_by_upload;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "canPayWithStripe", {
        get: function () {
            return includes(Object.keys(this.eventService.eventData.processors), 'stripe');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "stripePublicKey", {
        get: function () {
            try {
                return this.eventService.eventData.processors.stripe.pk;
            }
            catch (_a) {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "isStandardEvent", {
        get: function () {
            return (this.eventService.eventData.registrations.competitors.template ===
                'standard');
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "showSchoolForm", {
        get: function () {
            // TODO - can come from flag from backend
            return true;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "weightUnit", {
        get: function () {
            return this.eventService.eventData.registrations.competitors.weight;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "nocRequired", {
        get: function () {
            return this.eventService.eventData.registrations.competitors.noc;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "membershipIdField", {
        get: function () {
            return this.eventService.eventData.registrations.competitors
                .membership_id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "shirt_required", {
        get: function () {
            return this.eventService.eventData.registrations.competitors.shirt_size;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "message", {
        get: function () {
            return this.eventService.eventData.registrations.competitors.message;
        },
        enumerable: true,
        configurable: true
    });
    CompetitorRegistrationComponent.prototype.getExtraFields = function () {
        var output = {};
        if (this.membershipIdField) {
            output.membership_id = [
                '',
                this.membershipIdField.required ? Validators.required : [],
            ];
        }
        if (this.shirt_required) {
            output.shirt_size = ['', Validators.required];
        }
        return output;
    };
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "eventName", {
        get: function () {
            return this.eventService.eventData.name;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CompetitorRegistrationComponent.prototype, "formState", {
        get: function () {
            if (this.successHtml) {
                return 'RESET_FORM';
            }
            if (this.price === '0.00') {
                return 'FREE';
            }
            return 'PAY';
        },
        enumerable: true,
        configurable: true
    });
    CompetitorRegistrationComponent.prototype.ngOnInit = function () {
        this.paypalDefined = isPaypalDefined();
        this.getEventId();
        this.initializeForm();
        this.paymentCode =
            this.route.snapshot.queryParamMap.get('payment_code');
    };
    CompetitorRegistrationComponent.prototype.getEventId = function () {
        this.eventId = this.route.snapshot.parent.params.id;
    };
    // FORM Setup
    CompetitorRegistrationComponent.prototype.initializeForm = function () {
        if (this.isStandardEvent) {
            this.competitorForm = this.standardForm();
        }
        else {
            this.competitorForm = this.virtualForm();
        }
        this.watchFormForDivisions();
    };
    CompetitorRegistrationComponent.prototype.virtualForm = function () {
        var _this = this;
        return this.fb.group(__assign({ 
            // personal information
            name_first: ['', Validators.required], name_middle: [''], name_last: ['', Validators.required], birth_date: ['', Validators.required], gender: [null, Validators.required], rank: [null, Validators.required], weight: ['1', Validators.required], 
            // contact information
            email: ['', [Validators.required, Validators.email]], noc: [null, this.nocRequired ? Validators.required : []] }, this.getExtraFields(), { 
            // misc information
            school: this.createSchoolForm(), 
            // // parent information
            parent_name_first: [''], parent_name_middle: [''], parent_name_last: [''], parent_email: [''], 
            // legal stuff and subsrcriptions
            subscription: [false], legal_age: [false, Validators.requiredTrue], waiver: [false, Validators.requiredTrue], terms_and_conditions: [false, Validators.requiredTrue] }), {
            validator: function (control) { return _this.parentRequired(control); },
        });
    };
    CompetitorRegistrationComponent.prototype.standardForm = function () {
        var _this = this;
        return this.fb.group(__assign({ 
            // personal information
            name_first: ['', Validators.required], name_middle: [''], name_last: ['', Validators.required], birth_date: ['', Validators.required], gender: [null, Validators.required], rank: [null, Validators.required], height_ft: ['', Validators.required], height_in: ['', [Validators.required, Validators.max(11)]], weight: ['1', Validators.required], 
            // contact information
            email: ['', [Validators.required, Validators.email]], phone: ['', Validators.required], address: ['', Validators.required], address_2: [''], city: ['', Validators.required], state: ['', Validators.required], zip: ['', Validators.required], noc: [null, this.nocRequired ? Validators.required : null] }, this.getExtraFields(), { 
            // misc information
            school: this.createSchoolForm(), 
            // parent information
            parent_name_first: [''], parent_name_middle: [''], parent_name_last: [''], parent_email: [''], parent_phone: [''], 
            // legal stuff and subsrcriptions
            subscription: [false], legal_age: [false, Validators.requiredTrue], no_crime: [false, Validators.requiredTrue], waiver: [false, Validators.requiredTrue], terms_and_conditions: [false, Validators.requiredTrue], 
            // catchall: [false, Validators.requiredTrue],
            exhibition_consent: [false], no_concussion_60_days: [false, Validators.requiredTrue] }), {
            validator: function (control) { return _this.parentRequired(control); },
        });
    };
    CompetitorRegistrationComponent.prototype.createSchoolForm = function () {
        if (this.showSchoolForm) {
            return this.fb.group({
                id: [''],
                name: [''],
                master: [''],
                address: [''],
                address_2: [''],
                city: [''],
                state: [''],
                zip: [''],
                country: [''],
                phone: [''],
                email: [''],
                url: [''],
            }, {
                validator: this.schoolRequired,
            });
        }
        else {
            this.fb.group({
                id: ['100'],
            });
        }
    };
    CompetitorRegistrationComponent.prototype.watchFormForDivisions = function () {
        var _this = this;
        this.competitorForm.valueChanges
            .pipe(tap(function () { return (_this.payload = null); }), // in case user changes form after clicking 'go to payment' button
        filter(function (value) {
            return value.rank &&
                value.gender &&
                value.birth_date &&
                value.weight;
        }), map(function (value) {
            return {
                rank: value.rank,
                gender: value.gender,
                birth_date: value.birth_date,
                weight: value.weight,
            };
        }), distinctUntilChanged(function (a, b) {
            return (a.rank === b.rank &&
                a.gender === b.gender &&
                a.birth_date === b.birth_date &&
                a.weight === b.weight);
        }), mergeMap(function (value) {
            return _this.eventService.getDivisionData(_this.eventId, value.rank, value.gender, value.birth_date, value.weight);
        }))
            .subscribe(function (divisions) {
            _this.price = '';
            _this.divisions = divisions;
        });
    };
    CompetitorRegistrationComponent.prototype.onSelectDivision = function (divisionIds) {
        this.payload = null;
        this.selectedDivisionIds = divisionIds;
        this.getPrice();
    };
    CompetitorRegistrationComponent.prototype.getPrice = function () {
        var _this = this;
        var schoolId = this.competitorForm.value.school &&
            this.competitorForm.value.school.id;
        this.eventService
            .getPrice(this.eventId, this.selectedDivisionIds, schoolId)
            .subscribe(function (res) {
            _this.price = res.price;
        }, function (err) {
            _this.scrollToTitle();
            _this.alert.newAlert('There was an error in getting the price.', 'danger');
        });
    };
    CompetitorRegistrationComponent.prototype.schoolRequired = function (control) {
        var value = control.value;
        if (value.id === '') {
            return { required: true };
        }
        if (value.id !== '-1') {
            return null;
        }
        var schoolFields = [
            'id',
            'name',
            'master',
            'address',
            'city',
            'state',
            'zip',
            'phone',
        ];
        var output = {};
        schoolFields.forEach(function (field) {
            if (value[field] === '') {
                output[field] = { required: true };
            }
        });
        if (Object.keys(output).length > 0) {
            return output;
        }
        else {
            return null;
        }
    };
    CompetitorRegistrationComponent.prototype.parentRequired = function (control) {
        var value = control.value;
        if (!this.competitorForm || !this.isMinor(this.competitorForm)) {
            return null;
        }
        var parentFields = [
            'parent_name_first',
            'parent_name_last',
            'parent_email',
        ];
        var output = {};
        parentFields.forEach(function (field) {
            if (value[field] === '') {
                output[field] = { required: true };
            }
        });
        if (Object.keys(output).length > 0) {
            return output;
        }
        else {
            return null;
        }
    };
    CompetitorRegistrationComponent.prototype.isMinor = function (formGroup) {
        var birth_date = formGroup.get('birth_date').value;
        return this.calculateAge(new Date(birth_date)) < 18;
    };
    // Form submission
    CompetitorRegistrationComponent.prototype.preparePayload = function () {
        if (this.competitorForm.invalid) {
            this.scrollToTitle();
            this.alert.newAlert('Please fill out required fields', 'danger');
            this.showValidation = true;
            return false;
        }
        if (!this.price) {
            this.scrollToTitle();
            this.alert.newAlert('Please select at least one division to compete in', 'warning');
            return false;
        }
        var competitor = this.competitorForm.value;
        competitor.divisions = this.selectedDivisionIds;
        if (competitor.school && competitor.school.id === 'null') {
            delete competitor.school.id;
        }
        this.payload = competitor;
        return true;
    };
    CompetitorRegistrationComponent.prototype.goToPayment = function () {
        this.alert.closeAlert();
        if (this.preparePayload()) {
            this.paymentOptionModal.open();
        }
    };
    CompetitorRegistrationComponent.prototype.usePaymentCode = function () {
        this.paymentOptionModal.close();
        if (this.preparePayload()) {
            this.paymentCodeModal.open();
        }
    };
    CompetitorRegistrationComponent.prototype.usePayByUpload = function () {
        this.paymentOptionModal.close();
        if (this.preparePayload()) {
            this.payByUploadModal.open();
        }
    };
    CompetitorRegistrationComponent.prototype.useAuthorizeNet = function () {
        this.paymentOptionModal.close();
        if (this.preparePayload()) {
            this.authorizeModal.open();
        }
    };
    CompetitorRegistrationComponent.prototype.useStripe = function () {
        this.paymentOptionModal.close();
        if (this.preparePayload()) {
            this.payByStripeModal.open();
        }
    };
    CompetitorRegistrationComponent.prototype.registerForFree = function () {
        var _this = this;
        this.paymentOptionModal.close();
        if (this.preparePayload()) {
            this.eventService
                .postEntity(this.eventId, 'competitors', this.payload)
                .subscribe(function (res) {
                if (res && res._html_message) {
                    _this.successHtml = res._html_message;
                }
                else {
                    _this.alert.newAlert('There was an error', 'danger');
                }
            }, function (err) {
                // TODO - handle?
                _this.alert.newAlert('There was an error', 'danger');
            });
        }
    };
    CompetitorRegistrationComponent.prototype.scrollToTitle = function () {
        this.scrollIt(this.pageTitle.nativeElement);
    };
    CompetitorRegistrationComponent.prototype.onSuccess = function (successHtml) {
        this.scrollToTitle();
        this.successHtml = successHtml;
    };
    CompetitorRegistrationComponent.prototype.onError = function (error) {
        this.scrollToTitle();
        this.alert.newAlert('There was an error in processing your payment', 'danger');
    };
    CompetitorRegistrationComponent.prototype.resetForm = function () {
        this.competitorForm.reset();
        this.successHtml = '';
        this.showValidation = false;
        this.payload = null;
        this.divisions = [];
        this.hasSelectedPrefill = false;
        this.price = '';
    };
    // Modals
    CompetitorRegistrationComponent.prototype.openModal = function (event, modalName) {
        event.preventDefault();
        switch (modalName) {
            case 'waiver':
                this.waiverModal.open();
                break;
            case 'terms':
                this.termsModal.open();
                break;
            default:
                break;
        }
    };
    // helper methods
    CompetitorRegistrationComponent.prototype.generateSchoolName = function (school) {
        var output = school.name;
        if (school.city) {
            output += " - (" + school.city + ")";
        }
        return output;
    };
    CompetitorRegistrationComponent.prototype.needMoreDivisionData = function (value) {
        return (!value.rank || !value.gender || !value.birth_date || !value.weight);
    };
    CompetitorRegistrationComponent.prototype.getPhoneMask = function (formControl) {
        return getPhoneMask(this.competitorForm.get(formControl).value);
    };
    return CompetitorRegistrationComponent;
}());
export { CompetitorRegistrationComponent };
